import { jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-text.css';
import { EGDSHeadingTags, EGDSTypeAlignments, EGDSHeadingSizes, EGDSTypeOverflows, EGDSTypeHyphens } from '../types/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
import { useEGDSContext } from '../../utils/context-provider/index.esm.js';
const getClassNameList = classNames.bind(styles);
/**
 * Use for title/headings of pages, sections, articles, listings, rate plans, etc.
 * Ensure that you are choosing the correct semantic `tag` for your heading.
 */
const EGDSHeading = props => {
  const {
    align,
    children,
    className,
    tag,
    size,
    overflow,
    hyphens,
    domRef,
    typeStyle,
    ...attributes
  } = props;
  const Tag = tag && EGDSHeadingTags.get(tag) || EGDSHeadingTags.get('h3');
  const {
    data: contextData,
    context
  } = useEGDSContext();
  const {
    bottomScrimContext,
    overlayScrimContext,
    contextClassNames
  } = contextData ?? {};
  const wrapperClassNames = getClassNameList('uitk-heading', align && EGDSTypeAlignments.get(align), !bottomScrimContext && (size && EGDSHeadingSizes.get(size) || EGDSHeadingSizes.get(6)), overflow && EGDSTypeOverflows.get(overflow), hyphens && EGDSTypeHyphens.get(hyphens), bottomScrimContext && `in-bottom-scrim`, overlayScrimContext && `in-overlay-scrim`, context === 'uitk-dialog-context' && 'in-dialog', contextClassNames?.EGDSHeading, className, typeStyle && `uitk-type-style-${typeStyle.customStyle}`);
  return children ? jsx(Tag, {
    className: wrapperClassNames,
    ref: domRef,
    ...(typeStyle && {
      'type-style-theme': typeStyle.customTheme || 'standard'
    }),
    ...attributes,
    children: children
  }) : null;
};
EGDSHeading.displayName = 'EGDSHeading';
export { EGDSHeading };